/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import ChooseAuthenticator from './ChooseAuthenticator';
import {connect} from 'react-redux';
import {fetchIndexedData} from '../../actions/methods-display.actions';
import React from 'react';
import {Navigate} from 'react-router-dom';
import { ADD_METHOD_TYPE, getMethodIdFromUri, HOMEPAGE_URL } from '../../actions/navigation.actions';
import AuthenticatorContainer from './AuthenticatorContainer';
import {getTemplateKey} from '../../utils/key-generator';
import PropTypes from 'prop-types';
import { availableIndexedTemplatesType, categoriesType, enrolledIndexedTemplatesType } from '../../types/types';
import withParams from '../WithParams';
import { saveSessionStorageItem, storageItems } from '../../utils/local-storage';
import { parseQueryString } from '../../utils/url-functions';

class MethodEnrollment extends React.PureComponent {
    constructor(props) {
        super(props);

        this.props.fetchIndexedData();
    }

    renderTemplate(template) {
        // Don't render the template if no match was found
        if (!template) {
            return <Navigate to={HOMEPAGE_URL} />;
        }

        const key = getTemplateKey(template);
        return (
            <div className="ias-content-padding">
                <AuthenticatorContainer key={key} template={template} />
            </div>
        );
    }

    render() {
        // Store TASK_COMPLETE_REDIRECT
        const redirect = parseQueryString(window.location.search)[storageItems.TASK_COMPLETE_REDIRECT];
        if(redirect) {
            saveSessionStorageItem(storageItems.TASK_COMPLETE_REDIRECT, redirect);
        }

        const {
            availableIndexedTemplates,
            categories,
            enrolledIndexedTemplates,
            params: { methodUri, templateType },
            nonDefaultCategoriesEnrolled
        } = this.props;

        if (!availableIndexedTemplates || !enrolledIndexedTemplates) {
            return null;
        }

        // Determine what template the route we are rendering matches.
        // If it matches multiple, but only one is enrolled, render the enrolled template; otherwise render a page for
        // the user to choose one
        const methodId = getMethodIdFromUri(methodUri);
        const enrolledTemplatesOfMethod = enrolledIndexedTemplates[methodId];
        const availableTemplateOfMethod = availableIndexedTemplates[methodId];

        if (templateType === ADD_METHOD_TYPE) {
            return this.renderTemplate(availableTemplateOfMethod);
        }

        if (templateType) {
            const templateId = templateType;
            let template = null;
            if (enrolledTemplatesOfMethod) {
                for (let index = 0; index < enrolledTemplatesOfMethod.length; index++) {
                    if (enrolledTemplatesOfMethod[index].id === templateId) {
                        template = enrolledTemplatesOfMethod[index];
                        break;
                    }
                }
            }
            return this.renderTemplate(template);
        }

        if (enrolledTemplatesOfMethod) {
            if (enrolledTemplatesOfMethod.length === 1) {
                return this.renderTemplate(enrolledTemplatesOfMethod[0]);
            }
            else {
                let templates = enrolledTemplatesOfMethod;

                if (availableTemplateOfMethod) {
                    templates = templates.concat([availableTemplateOfMethod]);
                }

                return (
                    <ChooseAuthenticator
                        categories={categories}
                        nonDefaultCategoriesEnrolled={nonDefaultCategoriesEnrolled}
                        templatesOfType={templates}
                    />
                );
            }
        }

        return this.renderTemplate(availableTemplateOfMethod);
    }
}

MethodEnrollment.propTypes = {
    availableIndexedTemplates: availableIndexedTemplatesType,
    categories: categoriesType,
    enrolledIndexedTemplates: enrolledIndexedTemplatesType,
    nonDefaultCategoriesEnrolled: PropTypes.bool
};

const mapStateToProps = ({ methodsDisplay: {categories, indexedData} }) => ({...indexedData, categories});
const mapDispatchToProps = { fetchIndexedData };

export default withParams(connect(mapStateToProps, mapDispatchToProps)(MethodEnrollment));
